export default __webpack_public_path__ + "static/media/tiktok.209860b2.svg";